module.exports = __webpack_public_path__ + "static/media/canLeadToStroke.09ab7db0.mp3";